<template>
  <div :class="'image-manager image-manager-horizontal image-manager-' + uniqueid">
      <div class="example-full">
        <div v-bind:class="{'drop-zone' : $refs.upload && $refs.upload.dropActive}">
          <div class="upload">
            
            <div v-for="(file, index) in files" :key="file.id" :class="'file-container mgp-file-' + file.id">
              <div class="photo-container">
                <a v-if="file.thumb" :href="getImageLink(file)" class="thumb-link">
                  <img :src="file.thumb" width="150" height="auto" />
                </a>
                <span v-else>No Image</span>
              </div>
              <div class="file-status">
                <div v-if="file.error && file.error == 'size'" class='alert alert-error'>
                  This image is too large (> 10MB). <strong>It will not be included in your submission.</strong>
                </div>
                <div v-else-if="file.error">{{file.error}}</div>
                <div class="file-uplaoded" v-if="file.success">
                  <i class="fa fa-check fa-3x" style="color:green;"></i>
                  <strong style="color:green;font-size:2em;">File Uploaded</strong>
                </div>
                <div class="progress" v-else-if="file.active">
                  <div :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}" role="progressbar" :style="{width: file.progress + '%'}">{{file.progress}}%</div>
                </div>
              </div>
              <div class="actions">
                <a class="btn btn-danger btn-xs" @click.prevent="remove(file)">Remove</a>
              </div>
            </div>
            <div v-if="!files.length" class="dropzone grow">
              <div class="text-center">
                <h4>Drop files here to upload</h4>
              </div>
            </div>
            <div v-else class="grow"></div>
            <div class="text-center upload-button">
                <file-upload
                  class="btn btn-primary"
                  :post-action="postAction"
                  :extensions="extensions"
                  :accept="accept"
                  :multiple="multiple"
                  :directory="directory"
                  :size="size || 0"
                  :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                  :headers="headers"
                  :data="data"
                  :name="'original'"
                  :input-id="uniqueid"
                  :drop="drop"
                  :drop-directory="dropDirectory"
                  :add-index="addIndex"
                  v-model="files"
                  @input-filter="inputFilter"
                  @input-file="inputFile"
                  ref="upload">
                  Select File(s)
                </file-upload>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
export default {
  name: 'ImageManagerHorizontal',
  props: ['value', 'uniqueid'],
  components: {
    FileUpload,
  },
  data() {
    return {
      files: this.value ? this.value : [],
      accept: 'image/jpeg,image/png',
      extensions: 'jpg,jpeg,png',
      // extensions: ['gif', 'jpg', 'jpeg','png', 'webp'],
      // extensions: /\.(gif|jpe?g|png|webp)$/i,
      minSize: 12,
      size: 1024 * 1024 * 10,
      multiple: true,
      directory: false,
      drop: true,
      dropDirectory: false,
      addIndex: false,
      thread: 3,
      postAction: this.APIBaseURL() + 'sighting-photos/',
      headers: {
      },
      data: {
      },
      uploadAuto: true,
    }
  },
  mounted: function(){
    this.setupMagnificPopup();
  },
  watch: {
    'files': function(val){
      this.$emit('input', this.files);
      this.setupMagnificPopup();
    },
  },

  methods: {
    remove: function(file){
      var remove_index = this.$refs.upload.files.findIndex(f => f.id == file.id);
      if (remove_index >= 0) {
        this.$refs.upload.files.splice(remove_index, 1);
      }
    },
    getImageLink: function(file){
      if (!file.response || !file.response.sighting_photo || !file.response.sighting_photo.large) {
        return file.thumb;
      }
      return file.response.sighting_photo.large; 
    },
    setupMagnificPopup: function(){
      if(this.files.length > 0){
        $('.image-manager-' + this.uniqueid).magnificPopup({
          delegate: 'a.thumb-link',
          type: 'image',
          gallery:{
            enabled:true
          },
        });
      }
      
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file

        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }

        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }


      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {

        // Create a blob field
        newFile.blob = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file)
        }

        // Thumbnails
        newFile.thumb = ''
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob
        }
      }
    },
    // add, update, remove File Event
    inputFile(newFile, oldFile) {
      if (newFile && oldFile) {
        // update
        if (newFile.active && !oldFile.active) {
          // beforeSend
          // min size
          if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
            this.$refs.upload.update(newFile, { error: 'size' })
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
        }
        if (newFile.error && !oldFile.error) {
          // error
        }
        if (newFile.success && !oldFile.success) {
          // success
        }
      }
      if (!newFile && oldFile) {
        // remove
        if (oldFile.success && oldFile.response.id) {
          // $.ajax({
          //   type: 'DELETE',
          //   url: '/upload/delete?id=' + oldFile.response.id,
          // })
        }
      }
      // Automatically activate upload
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (this.uploadAuto && !this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
    },
    alert(message) {
      alert(message)
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ImageManagerHorizontal.vue